import Search from "@mui/icons-material/Search";
import {
  Box,
  Chip,
  ClickAwayListener,
  Portal,
  Stack,
} from "@mui/material";
import Card from "components/Cards/Card";
import Spin from "components/Spin";
import EmptyText from "components/UI/atoms/EmptyText";
import SearchInput from "components/UI/molecules/SearchInput";
import React, { useState } from "react";

const RelatedItemsSearchSelect = ({
  search,
  setSearch,
  t = (d) => d,
  placeholder = "Search",
  classes = "",
  containerRef,
  menuTop = "256px",
  items = [],
  loading = false,
  relatedItems = [],
  relatedTitle = "Related Skills",
  width = 650,
}) => {
  const [menuAnchor, setMenuAnchor] = useState();
  return (
    <ClickAwayListener onClickAway={() => setMenuAnchor(null)}>
      <div>
        <SearchInput
          classes={classes}
          height="40px"
          width={`${width}px`}
          placeholder={placeholder}
          t={t}
          search={search}
          setSearch={setSearch}
          onFocus={(e) => setMenuAnchor(e.currentTarget)}
        />
        {Boolean(menuAnchor) && (
          <Portal sx={{ zIndex: 9999 }} container={containerRef.current}>
            <Box
              className="absolute w-full"
              sx={{ top: menuTop, zIndex: 99999 }}
            >
              <Card
                classes={`mx-auto minh-200 px-2 py-2`}
                rounded="5px"
                width={`${width - 65}px`}
              >
                {loading ? (
                  <Box className="flex items-center justify-center h-300 w-full">
                    <Spin big blue />
                  </Box>
                ) : !items?.length ? (
                  <EmptyText classes="c-title">
                    {t("No result found!")}
                  </EmptyText>
                ) : (
                  <div>
                    {items?.map((d) => (
                      <Box
                        sx={{ ":hover": { background: "#F3F7FC" } }}
                        className="flex items-center py-1 cursor-pointer rounded-5"
                        onClick={() => setSearch(d?.value)}
                      >
                        <Search className="c-gray" />{" "}
                        <p className="ml-1 fs-15">{d?.value}</p>
                      </Box>
                    ))}
                    <p className="fw-600 mt-2 ml-1">{relatedTitle}</p>
                    <Stack
                      direction="row"
                      alignItems="center"
                      flexWrap="wrap"
                      gap={1}
                      className="my-1"
                    >
                      {relatedItems?.map((d) => (
                        <Chip
                          label={d?.value}
                          clickable
                          variant="outlined"
                          size="large"
                          className="border-darkgray rounded-10 cursor-pointer bg-gray c-title"
                          onClick={() => setSearch(d?.value)}
                        />
                      ))}
                    </Stack>
                  </div>
                )}
              </Card>
            </Box>
          </Portal>
        )}
      </div>
    </ClickAwayListener>
  );
};

export default RelatedItemsSearchSelect;
